//API keys
export var PurchaseOrderKeys = {
    Paging: "purchaseOrderPagingData",
    Status: "statusListPOGet",
    POList: "purchaseOrderListGet",
    Create: "",
    Update: "purchaseOrderUpdate",
    Get: "",
    PaymentTerm: "paymentTermPickList",
    PaymentMethod: "paymentMethodPickList",
    SupplierList: "supplierPickList",
    ShippingMethod: "shippingMethodPickList",
    ShippingTerm: "shippingTermPickList",
    Department: "departmentPickList",
    Warehouse: "wareHousePickList",
    Priority: "priorityPickList",
    PurchaseOrderList: "purchaseOrderList",
    ItemsPaging: "poItemsPagingAPI",
    Search: "searchPurchaseNo",
    PRGet: "purchaseOrderProcurementGet",
    PartDetail: "PurchaseOrderPartDetailGet",
    OrganizationAddress: "OrganizationAddressPickListData",
    CreatePurchaseOrder: "CreatePurchaseOrderData",
    PartDetailsByProductId: 'getPartDetailsByProductId',
    PurchaseOrderById: "getPurchaseOrderByIdData",
    POGet: "getPurchaseOrder",
    Cancel: "cancelPurchaseOrder",
    AttachmentSystemName: 'PurchaseOrderAttachment',
    Upload: 'purchaseOrderUpload',
    attachmentList: "attachmentList"
};
export var showColumnName = {
    DocumentNumber: "Order number",
    PurchaseOrderTypeName: "PO Type",
    StatusName: "Status",
    SupplierName: "Supplier name",
    PurchaseOrderCreatedByName: "Created by",
    PurchaseOrderCreatedDateTime: "Created date",
    EstimateDeliveryDateTime: "Fulfilment date",
    Amount: "Amount (₹)"
};
